import styled, { css } from "styled-components";

const FiltersWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    height: 5rem;
    margin-top: 3rem;
    margin-bottom: 3rem;
`;

const Filter = styled.button`
    border: ${props => props.theme.lightGrayBorder};
    padding: 0 0.8rem;
    border-radius: 0.5rem;
    font-family: ${props => props.theme.fontBold};
    font-weight: bold;
    font-size: 1rem;
    cursor: pointer;
    margin-right: 0.5rem;
    @media only screen and (min-width: ${props => props.theme.smallMobile}) {
        font-size: 1.3rem;
    }
    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        padding: 0 2rem;
        font-size: 1.4rem;
        margin-right: 1rem;
    }
    ${props =>
        props.active &&
        css`
            border: ${props.theme.greenBorder};
        `}
`;

export { FiltersWrapper, Filter };
